import { React } from "react";
import './logo.styles.scss'

const Logo = () => (
    <div className="animate__animated animate__bounceInLeft logo">
        <img src="https://user-images.githubusercontent.com/16614788/126889570-19aaa09a-2b12-4f7f-b6ba-bb70bf7c7416.jpg" alt="logo"  />
    </div>
)

export default Logo;